export default __webpack_public_path__ + "static/media/KOD0025-min.97302e90.webp";